import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const API_URL = "https://api.securxperts.com:8000/receipts";

const Getstudent = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchStudents();
  }, []);

const fetchStudents = async () => {
  try {
    setLoading(true);
    setError("");

    // ✅ GET TOKEN CORRECTLY
    const token = sessionStorage.getItem("access_token");

    if (!token) {
      setError("Unauthorized. Please login again.");
      setLoading(false);
      return;
    }

    const res = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (res.status === 401) {
      setError("Session expired. Please login again.");
      sessionStorage.removeItem("access_token");
      return;
    }

    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }

    const data = await res.json();
    setStudents(data.items || []);
  } catch (err) {
    setError("Failed to load student receipts.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
     

      <section className="max-w-7xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Student Receipt Records
        </h1>

        {loading && (
          <div className="text-center py-20 text-lg font-medium">
            Loading receipts...
          </div>
        )}

        {error && (
          <div className="text-center py-10 text-red-600 font-semibold">
            {error}
          </div>
        )}

        {!loading && !error && (
          <div className="overflow-x-auto bg-white shadow-xl rounded-xl">
            <table className="min-w-full text-sm">
              <thead className="bg-indigo-900 text-white">
                <tr>
                  <th className="px-4 py-3 text-left">Name</th>
                  <th className="px-4 py-3 text-left">Mobile</th>
                  <th className="px-4 py-3 text-left">Email</th>
                  <th className="px-4 py-3 text-left">Referred By</th>
                  <th className="px-4 py-3 text-left">Date</th>
                  <th className="px-4 py-3 text-center">Receipt</th>
                </tr>
              </thead>

              <tbody>
                {students.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-8 text-gray-500">
                      No records found
                    </td>
                  </tr>
                ) : (
                  students.map((item, idx) => (
                    <tr
                      key={idx}
                      className="border-b hover:bg-gray-50 transition"
                    >
                      <td className="px-4 py-3 font-medium">
                        {item.student_name}
                      </td>
                      <td className="px-4 py-3">
                        {item.student_mobile}
                      </td>
                      <td className="px-4 py-3">
                        {item.student_email}
                      </td>
                      <td className="px-4 py-3">
                        {item.referred_by || "-"}
                      </td>
                      <td className="px-4 py-3">
                        {new Date(item.date).toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {item.pdf_url ? (
                          <a
                            href={item.pdf_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block bg-blue-600 text-white px-4 py-1.5 rounded-lg text-xs hover:bg-blue-700 transition"
                          >
                            View PDF
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </section>

    </div>
  );
};

export default Getstudent;
